import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { handleApiCall } from '@/api/utils/handleApiCall';

// Define response type
export type ApiResponse_GetPublic_GroupNegotiation = {
  id: number;
  title: string;
  description: string | null;
  status: string;
  communityId: number;
  communityName: string;
  memberCount: number;
  targetMemberCount: number;
  savingsAmount: number;
  originalCost: number;
  savingsPercentage: number;
  activeGroupCount: number;
  pricingTiers?: Array<{
    minHomes: number;
    maxHomes?: number;
    pricePerHome: number;
  }>;
  vendor?: {
    name?: string;
    email?: string;
    phone?: string;
  };
};

// Define constants
const METHOD = 'GET';
const ENDPOINT = 'negotiation/public/group/:id';
export const QUERY_KEY = (id: number) => getQueryKey(METHOD, ENDPOINT, { id });

// Create hook - no auth required for public endpoint
export const useGetPublicGroupNegotiation = (id: number, enabled = true) => useQuery({
  enabled: enabled && !!id,
  queryKey: QUERY_KEY(id),
  queryFn: async () => {
    const data = await handleApiCall<ApiResponse_GetPublic_GroupNegotiation>(
      null, // No session needed for public endpoint
      METHOD,
      `negotiation/public/group/${id}`
    );
    return data;
  },
});